export const addressInvalid = (currentAdress: any) => {
  const checkKeyList = ['CityCode', 'Town', 'District', 'Street', 'AddressDetail', 'PostalCode'];
  const checkValue = ['', 'null', 'yok'];
  return Object.entries(currentAdress).some(
    ([key, value]) =>
      checkKeyList.includes(key) &&
      (!value || (value as string)?.length < 1 || checkValue.includes(String(value)?.toLocaleLowerCase()))
  );
};
